import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

const LoanPerson = Loadable(lazy(() => import("pages/loan/Person")));
const Details = Loadable(lazy(() => import("pages/loan/Details")));
const LoanList = Loadable(lazy(() => import("pages/loan")));
const Receipt = Loadable(lazy(() => import("pages/loan/Receipt")));
const LoanReturn = Loadable(lazy(() => import("pages/loan/LoanReturn")));
const LoanProfit = Loadable(lazy(() => import("pages/loan/LoanProfit")));

const LoanRoutes = {
  path: "loan",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "person",
      element: <LoanPerson />,
    },
    {
      path: "details/:id",
      element: <Details />,
    },
    {
      path: "list",
      element: <LoanList />,
    },
    {
      path: "receipt/:id",
      element: <Receipt />,
    },
    {
      path: "return",
      element: <LoanReturn />,
    },
    {
      path: "profit",
      element: <LoanProfit />,
    },
  ],
};

export default LoanRoutes;
